import React, { useEffect, useState } from "react";
import "../styles/AssessmentFeedbackComponentStyle.css";
import JozunaLogo from "../../../assets/images/assessment_feedback/jozuna_logo.svg";
import { Col, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../../service/ApiContext";
import { LocalStorage } from "../../../utils/Utils";
import Logger from "../../../utils/Logger";
import FeedBack from "../data/ApiClient/feedBackClient";
import { FeedBackResponse } from "../data/response/FeedBackReponse";
import { FeedbackRequest } from "../data/request/FeedBackRequest";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useAlert } from "../../../components/AlertContextComponent";
import AssessmentQuestionModuleApiService from "../../assessment_question/data/api_services/QuestionModuleApi";
import { OverlaySingleErrorPoppup } from "../../../components/OverlayErrorPopup";
import {
  clearAssessment,
  clearAssessmentId,
} from "../data/redux/AssessmentSlice";
import { useCamera } from "../../assessment_question/components/CameraContext";
import {
  logActionEvent,
  logPageView,
} from "../../../analytics/analytics_utils";
import strings from "../../../utils/Strings";
import analytics_strings from "../../../analytics/analytics_strings";

interface AssessmentFeedbackComponentProps {
  setIsChildWindowOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const AssessmentFeedbackComponent: React.FC<
  AssessmentFeedbackComponentProps
> = ({ setIsChildWindowOpen }) => {
  const navigate = useNavigate();
  const handleCloseFeedback = () => {
    setIsChildWindowOpen(false); // Close feedback form
    navigate("/dashboard/student");
  };
  const { showAlert } = useAlert();
  const [isSetErrorMsg, setIsErrorMsgPopup] = useState<string | null>(null); //show error popups
  const dispatch = useDispatch();
  const assessmentId = useSelector(
    (state: RootState) => state.assessment.assessmentId,
  );
  // Select the data from the Redux store
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const api = useApi();
  const { stopCamera } = useCamera();
  const [like, setLike] = useState<boolean | null>(null);
  const [recommend, setRecommend] = useState<boolean | null>(null);

  const [difficult, setDifficult] = useState<string | null>(null);
  const [select, setSelect] = useState<boolean>(false);
  const email = useSelector(
    (state: RootState) => state.profile.profileKeys.contact_email,
  );
  const questionModuleApiService = AssessmentQuestionModuleApiService(); //API Service Class for question module
  const FeedSubmit = async () => {
    if (difficult === null || like === null || recommend === null) {
      // setSelect(true)
      Logger.info("mandatory");
      setIsErrorMsgPopup(
        "Please answer all the feedback questions in order to submit the assessment",
      );
      return;
    }
    const param: FeedbackRequest = {
      like: !like,
      difficulty_level: difficult ?? "",
      recommend: !recommend,
    };
    logActionEvent(analytics_strings.analytics_events.feedbackButton, {
      candidate_id: userData.candidate_id,
    });

    const feedbackUrlWithAssessmentId = `${FeedBack.feedBackUrl}${assessmentId}/feedback`;
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      const response = await api
        .post<FeedBackResponse>(feedbackUrlWithAssessmentId, param)
        .then((res) => {
          if (res?.data?.error === null) {
            setIsChildWindowOpen(false); // Close feedback form
            dispatch(clearAssessmentId());
          } else {
            setIsErrorMsgPopup(res.data.error);
          }
        })
        .catch((error) => {
          Logger.info("error response", error);
        });
    } catch (error) {
      Logger.info("error response", error);
    } finally {
    }
  };
  useEffect(() => {
    //Log Analytics Feedback Page
    logPageView(analytics_strings.analytics_path.assessmentFeedBackPage);
    return () => {
      questionModuleApiService.clearAssessmentLocalStorage(); //Clear the Local Storage
      navigate("/dashboard/student");
      //Closing Assessment Camera
      stopCamera();
      window.location.reload();
    };
  }, []);
  return (
    <div className="assessment-feedback-page">
      <img
        src={JozunaLogo}
        alt="Jozuna logo"
        className="assessment-jozuna-logo"
      />
      {/* {userData.logo_url ? (
        <img src={userData.logo_url} className="header-nojozuna-image"></img>
      ) : (
        <img src={JozunaLogo} alt="Logo" className="assessment-jozuna-logo" />
      )} */}
      <div className="assessment-feedback-content">
        {/* <div className="assessment-content-heading">Congrats!</div> */}
        <div className="assessment-content-subheading">
          Thank you for taking the assessment. The detailed report will be
          shared on your email address <span>'{email}'</span>
        </div>
        <div className="feedback-container">
          <h2 className="feedback-title">Quick Feedback</h2>
          <form>
            <div className="feedback-question">
              <Row>
                <Col>
                  <label>Did you like taking the assessment?</label>
                </Col>
                <Col>
                  <div
                    className="feedback-options"
                    // style={{ marginLeft: "300px", gap: "25px" }}
                  >
                    <label>
                      <input
                        type="radio"
                        name="likeAssessment"
                        value="yes"
                        onClick={() => {
                          setLike(true);
                        }}
                      />
                      Yes
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="likeAssessment"
                        value="no"
                        onClick={() => {
                          setLike(false);
                        }}
                      />
                      No
                    </label>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="feedback-question">
              <Row>
                <Col>
                  <label>What was the difficulty level?</label>
                </Col>
                <Col>
                  <div
                    className="feedback-options"
                    // style={{ marginLeft: "99px", gap: "25px" }}
                  >
                    <label>
                      <input
                        type="radio"
                        name="difficultyLevel"
                        value="low"
                        onClick={() => setDifficult("Easy")}
                      />
                      Easy
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="difficultyLevel"
                        value="medium"
                        onClick={() => setDifficult("Medium")}
                      />
                      Medium
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="difficultyLevel"
                        value="high"
                        onClick={() => setDifficult("Hard")}
                      />
                      Hard
                    </label>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="feedback-question">
              <Row>
                <Col>
                  <label>
                    Will you recommend taking this assessment to your friends?
                  </label>
                </Col>
                <Col>
                  <div
                    className="feedback-options"
                    // style={{ marginLeft: "100px", gap: "25px" }}
                  >
                    <label>
                      <input
                        type="radio"
                        name="recommend"
                        value="yes"
                        onClick={() => setRecommend(true)}
                      />
                      Yes
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="recommend"
                        value="no"
                        onClick={() => setRecommend(false)}
                      />
                      No
                    </label>
                  </div>
                </Col>
              </Row>
            </div>
            <button
              type="button"
              className="close-button-assessment"
              disabled={
                difficult === "" || null || like === null || recommend === null
              }
              onClick={FeedSubmit}
            >
              Submit
            </button>
          </form>
        </div>
      </div>
      {/* {isSetErrorMsg !== null && (
        <OverlaySingleErrorPoppup
          title="Error"
          body={isSetErrorMsg}
          button1Text="Ok"
          button1CallBack={() => {
            setIsErrorMsgPopup(null);
          }}
        />
      )} */}
    </div>
  );
};

export default AssessmentFeedbackComponent;
